import { IPaginaInfo, PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { Col, Divider, Empty, Form, FormProps, Button, Row } from "antd";
import { useConciliacaoAuttarLogsPaginar, useConciliacaoAuttarPaginar } from "@/Services/Financeiro/Conta/ConciliacaoAuttarService";
import { useEffect, useState } from "react";
import ComponentePermissao, { usePermitido } from "@/Components/Base/Permissao/ComponentePermissao";
import CarregamentoComponentes from "@/Components/Base/Carregamento";
import TrabalhoLog from "@/Models/Sistema/Trabalho/TrabalhoLog";
import ConciliacaoLogTableBasic, { IConciliacaoLogTableBasicProps } from "./ConciliacaoLogTableBasic";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";

export interface IConciliacaoLogTableFormType {
    pagina:IPaginaInfo;
    trabalhoLog?:TrabalhoLog;
    ativo?:boolean;
}

export interface IConciliacaoLogTableProps extends FormProps<IConciliacaoLogTableFormType> {
    tableProps?:Omit<IConciliacaoLogTableBasicProps, "dataSource">;
    codTrabalhoTipo:EnumTrabalhoTipo;
}

export default function ConciliacaoLogTable ({
    form : formParam,
    initialValues,
    tableProps,
    component,
    layout,
    codTrabalhoTipo,
    ...rest
}:IConciliacaoLogTableProps) {
    const [newForm] = Form.useForm<IConciliacaoLogTableFormType>();
    const form = formParam ?? newForm;
    const inputRequest = Form.useWatch([], form);
    const [ consultar, setConsultar ] = useState(true);

    const {
        permitido
    } = usePermitido({
        permissoes : [ "FinanceiroContaConciliacaoAuttarLogListar" ]
    });

    const {
        data,
        isLoading,
        isSuccess,
        isError,
    } = useConciliacaoAuttarLogsPaginar({
        ...inputRequest,
        codTrabalhoTipo,
        pagina : inputRequest?.pagina ?? new PaginaInfo(),
        enabled : permitido && consultar,
        onFinish() {
            setConsultar(false);
        },
    });

    return <Form
        {...rest}
        form={form}
        component={component === undefined ? "div" : component}
        layout={layout === undefined ? "vertical" : layout}
        initialValues={{
            ...initialValues,
            pagina : initialValues?.pagina === undefined ? new PaginaInfo() : initialValues?.pagina,
            ativo : initialValues?.ativo === undefined ? true : initialValues.ativo,
        }}
        onFinish={(data) => {
            form.setFieldsValue({
                pagina : {
                    pagina : 1
                }
            } as any);
            //refetch();
            setConsultar(true);
        }}
    >
        <Form.Item hidden name="ativo"></Form.Item>
        <Form.Item hidden name="pagina"></Form.Item>
        <Form.Item hidden name="trabalhoLog"></Form.Item>
        {
            (isSuccess || isLoading) && <>
                <Divider>Registros</Divider>
                {/* <CarregamentoComponentes.TelaCarregamento ativo={isLoading || !!tableProps?.loading}> */}
                <ConciliacaoLogTableBasic 
                    {...tableProps}
                    codTrabalhoTipo={codTrabalhoTipo}
                    loading={isLoading || !!tableProps?.loading}
                    dataSource={data}
                    onSuccess={() => form.submit()}
                    onChange={(pagina) => {
                        form.setFieldsValue({
                            pagina : {
                                pagina : pagina.current ?? 1,
                                tamanho : pagina.pageSize ?? 15
                            }
                        } as any);

                        setConsultar(true);
                    }} 
                />
                {/* </CarregamentoComponentes.TelaCarregamento> */}
            </> || <>
                <Empty description={isError ? "Ocorreu um erro, tente novamente!" : "Clique em \"Listar\" para realizar a consulta."} />
            </>
        }
    </Form>;
}